import React, { Component } from 'react'
import {InfoDebtor} from '../../calculator/components/partials'

export default class InfoCreditorContainer extends Component{


  render(){
    return(
      <div className="calculator-wrapper">
        <InfoDebtor/>
      </div>

    )
  }

}


// WEBPACK FOOTER //
// ./src/features/pages/containers/InfoDebtorContainer.js